import Service from "./Service";
import {isEmpty} from 'lodash';
const baseurl = '/api/egreso-vacunas';
export default {
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
    async index(search = '',pagination = {}) {
        let url = `${baseurl}?`;

        url += search !== '' ? `s=${search}` : '';

        url += (!isEmpty(pagination))
            ? `&paginate=true&per_page=${pagination.per_page}&page=${pagination.page}`
            : '';

        return Service.get(url);
    },
    cant_by_lote(params = {}) {
        return Service.get(`api/vacunas/cant-by-lote`, {
            params : params
        });
    },
    imprimir(id){
        return `${process.env.VUE_APP_BASE_PATH}${baseurl}/imprimir/${id}`
    },
}
